import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ILicenseLinkInfo } from '../../../models_new/classes/api-models/ApiSoftwareLicense';
import { Observable, of, take } from 'rxjs';
import { DataRequestState } from 'src/app/data-request/model';
import { toRequestState } from 'src/app/data-request/operators';

@Component({
  selector: 'app-ir-license',
  templateUrl: './ir-license.component.html',
  styleUrls: ['./ir-license.component.scss'],
})
export class IrLicenseComponent {
  licenses$: Observable<DataRequestState<ILicenseLinkInfo[]>>;

  constructor(
    public dialogRef: MatDialogRef<IrLicenseComponent>,
    @Inject(MAT_DIALOG_DATA)
    public input: {
      data: {
        licenses: ILicenseLinkInfo[];
      };
    }
  ) {
    this.licenses$ = of(this.input.data.licenses).pipe(
      take(1),
      toRequestState()
    );
  }

  close() {
    this.dialogRef.close();
  }
}
